/**
 * Firestore Upload Utilities
 * Handle data uploads and synchronization with Firestore
 */

import { db } from '../firebaseconf';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Upload marks data to Firestore
 */
export const uploadMarksData = async (institutionId, marksData) => {
    try {
        const promises = [];

        for (const mark of marksData) {
            const docRef = addDoc(collection(db, 'institutions', institutionId, 'marks'), {
                ...mark,
                institution_id: institutionId,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
            promises.push(docRef);
        }

        await Promise.all(promises);
        return { success: true, count: marksData.length };
    } catch (error) {
        console.error('Error uploading marks:', error);
        throw error;
    }
};

/**
 * Upload attendance data to Firestore
 */
export const uploadAttendanceData = async (institutionId, attendanceData) => {
    try {
        const promises = [];

        for (const attendance of attendanceData) {
            const docRef = addDoc(collection(db, 'institutions', institutionId, 'attendance'), {
                ...attendance,
                institution_id: institutionId,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
            promises.push(docRef);
        }

        await Promise.all(promises);
        return { success: true, count: attendanceData.length };
    } catch (error) {
        console.error('Error uploading attendance:', error);
        throw error;
    }
};

/**
 * Upload student assignments to Firestore
 */
export const uploadAssignments = async (institutionId, assignmentData) => {
    try {
        const promises = [];

        for (const assignment of assignmentData) {
            const docRef = addDoc(collection(db, 'institutions', institutionId, 'assignments'), {
                ...assignment,
                institution_id: institutionId,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
            promises.push(docRef);
        }

        await Promise.all(promises);
        return { success: true, count: assignmentData.length };
    } catch (error) {
        console.error('Error uploading assignments:', error);
        throw error;
    }
};

/**
 * Upload student submissions to Firestore
 */
export const uploadSubmissions = async (institutionId, submissionData) => {
    try {
        const promises = [];

        for (const submission of submissionData) {
            const docRef = addDoc(collection(db, 'institutions', institutionId, 'submissions'), {
                ...submission,
                institution_id: institutionId,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
            promises.push(docRef);
        }

        await Promise.all(promises);
        return { success: true, count: submissionData.length };
    } catch (error) {
        console.error('Error uploading submissions:', error);
        throw error;
    }
};

/**
 * Upload all dummy data
 */
export const uploadAllDummyData = async (institutionId, allData) => {
    try {
        const results = {};

        if (allData.marks) {
            results.marks = await uploadMarksData(institutionId, allData.marks);
        }
        if (allData.attendance) {
            results.attendance = await uploadAttendanceData(institutionId, allData.attendance);
        }
        if (allData.assignments) {
            results.assignments = await uploadAssignments(institutionId, allData.assignments);
        }
        if (allData.submissions) {
            results.submissions = await uploadSubmissions(institutionId, allData.submissions);
        }

        return { success: true, results };
    } catch (error) {
        console.error('Error uploading all dummy data:', error);
        throw error;
    }
};
